import { AlertColor } from "@mui/material";

type AlertFn = (type: AlertColor, message: string, duration?: number) => void;

let showAlertRef: AlertFn = () => {
  console.warn("showAlert called before initialization");
};

export const setShowAlertRef = (fn: AlertFn) => {
  showAlertRef = fn;
};

export const showAlert = (...args: Parameters<AlertFn>) => {
  showAlertRef(...args);
};
